import { NavLink, Outlet, Navigate, useLocation } from 'react-router-dom';
import { Package, Heart, Search, Landmark } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import LogoutButton from '../../components/LogoutButton';

const TABS = [
  { to: '/account/orders', label: 'Orders', icon: Package },
  { to: '/account/wishlist', label: 'Wishlist', icon: Heart },
  { to: '/account/requests', label: 'Requests', icon: Search },
];

// Only a consignor sees this. Everybody else's menu is unchanged.
const CONSIGNOR_TAB = { to: '/account/banking', label: 'My Banking', icon: Landmark };

// Shell for the signed-in customer area. Guards auth once here so the three
// tabs (Orders / Wishlist / Requests) don't each repeat it.
export default function AccountLayout() {
  const { user, isLoading, isConsignor } = useAuth();
  const { pathname } = useLocation();

  if (isLoading) return <div className="sv-container" style={{ padding: 60 }}>Loading…</div>;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(pathname)}`} replace />;

  return (
    <div className="sv-container" style={{ paddingBlock: '46px 80px', maxWidth: 720 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, marginBottom: 18 }}>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 900, margin: 0 }}>My Account</h1>
        <LogoutButton
          className="sv-btn-outline"
          style={{ display: 'inline-flex', alignItems: 'center', gap: 7, padding: '9px 15px', fontSize: '0.88rem', fontWeight: 700, flexShrink: 0 }}
        />
      </div>

      <div
        style={{
          display: 'flex', gap: 6, marginBottom: 28, flexWrap: 'wrap',
          borderBottom: '1px solid var(--border)', paddingBottom: 2,
        }}
      >
        {(isConsignor ? [...TABS, CONSIGNOR_TAB] : TABS).map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            style={({ isActive }) => ({
              display: 'inline-flex', alignItems: 'center', gap: 7,
              padding: '9px 15px', fontSize: '0.9rem', fontWeight: 700,
              color: isActive ? 'var(--accent)' : 'var(--text-muted)',
              borderBottom: isActive ? '2px solid var(--accent)' : '2px solid transparent',
              marginBottom: -3,
            })}
          >
            <Icon size={16} />
            {label}
          </NavLink>
        ))}
      </div>

      <Outlet />
    </div>
  );
}
